<template>
  <vs-popup class="add-new-company-holiday"
            :title="titleFactory() + ' ORDERS'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div id="rm-orders-partial-status-change-popup">

        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateQcTest)" autocomplete="off">

          <vs-table :onlyClickCheckbox="true" stripe multiple v-model="selectedRms" @selected="handleSelected"  :data="items">

            <template slot="thead">
              <vs-th width="15%">COMPANY CODE</vs-th>
              <vs-th width="15%">COMPANY NAME</vs-th>
              <vs-th width="15%">QUANTITY (KG)</vs-th>
              <vs-th width="15%">PRICE (GBP)</vs-th>
              <vs-th width="15%">ORDER STATUS (QC)</vs-th>
              <vs-th width="15%">ITEM STATUS</vs-th>
              <vs-th width="15%"  class="justify-end ml-auto mr-0">TOTAL PRICE (GBP)</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].company_product_code">
                  {{ data[indextr].company_product_code }}
                </vs-td>

                <vs-td :data="data[indextr].company_product_name">
                  {{ data[indextr].company_product_name }}
                </vs-td>

                <vs-td :data="data[indextr].quantity">
                  {{ data[indextr].quantity }}
                </vs-td>

                <vs-td :data="data[indextr].price">
                  {{ (Number(data[indextr].price)).toFixed(2) }}
                </vs-td>

                <vs-td :data="data[indextr].q_c_status">
                  {{ data[indextr].q_c_status || 'N/A'}}
                </vs-td>

                <vs-td :data="data[indextr].item_status">
                  <vs-chip v-if="data[indextr].item_status" class="text-center text-xs" transparent :color="itemStatusColorFactory(data[indextr].item_status)">
                    {{ data[indextr].item_status || ''}}
                  </vs-chip>
                </vs-td>

                <vs-td  class="flex justify-end mr-4" :data="data[indextr].price">
                  {{data[indextr].quantity ? (Number(data[indextr].price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Submit</vs-button>
          </div>
        </form>
      </ValidationObserver>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const InventoryRepository = RepositoryFactory.get('inventory');
  import {raw_material_order_item_statuses} from '@/constants/statuses'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";

  function initialState() {
    return {
      open: false,
      id: '',
      form: {},
      isCreateMode: true,
      status: '',
      items: [],
      raw_material_order_item_statuses: raw_material_order_item_statuses,
      selectedRms: [],
      test_types: [
        {name: 'Do No Sample', value: 'in:Do_No_Sample'},
        {name: 'Odour and Appearance Check', value: 'Odour_and_Appearance_Check'},
        {name: 'Taste Odour and Appearance Check', value: 'Taste_Odour_and_Appearance_Check'},
        {name: 'Odour Appearance SG and RI Check', value: 'Odour_Appearance_SG_and_RI_Check'}
      ]
    }
  }

  export default {
    name: 'AddQcTestRmOrderItemPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id, status, items) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.id = id
          this.status = status
          await this.itemArrayFilter(items, status)
          this.open = true;
        } catch (error) {

        }
      },
      async itemArrayFilter(items, status) {
        if (status === 'part_accepted') {
          this.items = items.filter((n) => n.item_status === 'Not Accepted' || n.item_status === 'Pending')
        } else if (status === 'part_dispatched') {
          this.items = items.filter((n) => n.item_status === 'Not Dispatched' || n.item_status === 'Pending Dispatch')
        } else if (status === 'part_received') {
          this.items = items.filter((n) => n.item_status === 'Dispatched' || n.item_status === 'Not Received')
        } else if(status === 'part_return') {
          this.items = items.filter((n) => n.item_status === 'Received')
        }else  {
          this.items = items
        }
      },
      handleSelected(data) {

      },
      async onClickCreateQcTest() {
        const vue = this;
        await this.$vs.loading({
          container: '#rm-orders-partial-status-change-popup',
          scale: 0.45
        })
        try {
          const ids = this.selectedRms.map((n) => n.id)
          const payload = {raw_material_item_id: ids}
          await InventoryRepository.rmOrdersStatusChange(this.id, this.status, payload)
          this.showSuccessMessage('Status change successfully!')
          await vue.$parent.getProductOrderList();
          this.open = false;
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-orders-partial-status-change-popup > .con-vs-loading')
      },
      titleFactory() {
        switch (this.status) {
          case 'part_accepted':
            return 'PART ACCEPT'
            case 'part_dispatched':
              return 'PART DISPATCHED'
            case 'part_received':
              return 'PART RECEIVED'
            case 'part_return':
              return 'PART RETURN'
        }
      },
      itemStatusColorFactory(status) {
        const obj = this.raw_material_order_item_statuses.find((n) => n.name === status)
        return obj.color
      }
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-company-holiday >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 80% !important;
  }

</style>
